<span class="effect" [ngClass]="{ fh: edition === 'fh', city: eventType === 'city', disabled: disabled, selected: selected() }">
  @if (effectString) {
    <span class="text" [ngClass]="{ concatenated: concatenated(), inline: inline(), debug: debug() }">
      <span [ngClass]="{ 'text-white': light() }" [ghs-label]="effectString"></span>
    </span>
  }
  @if (effectObject) {
    <span class="effect-object" [ngClass]="{ light: light(), inline: inline() || concatenated() }">
      @if (effectObject.condition) {
        <ghs-event-card-condition
          [condition]="effectObject.condition"
          [edition]="edition"
          [eventType]="eventType"
          [light]="light()"
        ></ghs-event-card-condition>
      }
      @if (effectObject.condition) {
        <span class="condition-spacer">:</span>
      }
      @if (effectObject.type && !special.includes(effectObject.type)) {
        <span
          class="text"
          [ngClass]="{ 'text-white': light(), concatenated: concatenated() }"
          [ghs-label]="'game.events.effects.' + effectObject.type + (effectObject.alt ? '.' + effectObject.alt : '')"
          [ghs-label-args]="labelArgs"
          [slice]="concatenated() ? [0, -1] : []"
        ></span>
      }
      @if (effectObject.type === 'choose') {
        <span class="choose-container">
          <span [ngClass]="{ 'text-white': light() }" [ghs-label]="'game.events.effects.choose.prefix'"></span>
          @for (
            chooseEffect of effects;
            track (typeof chooseEffect === 'object' ? chooseEffect.type : chooseEffect) + ('' + $index);
            let i = $index
          ) {
            @if (i > 0) {
              <span [ngClass]="{ 'text-white': light() }" [ghs-label]="'game.events.effects.choose.connector'"></span>
            }
            <ghs-event-card-effect
              [effect]="chooseEffect"
              [edition]="edition"
              [eventType]="eventType"
              [light]="light()"
              [concatenated]="true"
            ></ghs-event-card-effect>
          }
          <span [ngClass]="{ 'text-white': light() }" [ghs-label]="'game.events.effects.choose.suffix'"></span>
        </span>
      }
      @if (effectObject.type === 'additionally') {
        <span class="additional-container">
          <span [ngClass]="{ 'text-white': light() }" [ghs-label]="'game.events.effects.additionally'"></span>
          @if (effects.length === 1) {
            <ghs-event-card-effect
              [effect]="effects[0]"
              [edition]="edition"
              [eventType]="eventType"
              [light]="light()"
              [inline]="true"
              [concatenated]="true"
              [selected]="selected()"
            ></ghs-event-card-effect>
          }
        </span>
      }
      @if (effectObject.type === 'and') {
        <span class="and-container">
          @for (andEffect of effects; track (typeof andEffect === 'object' ? andEffect.type : andEffect) + ('' + $index); let i = $index) {
            @if (i > 0) {
              <span [ngClass]="{ 'text-white': light() }" [ghs-label]="'game.events.effects.and'"></span>
            }
            <ghs-event-card-effect
              [effect]="andEffect"
              [edition]="edition"
              [eventType]="eventType"
              [light]="light()"
              [concatenated]="true"
              [selected]="selected()"
            ></ghs-event-card-effect>
          }
        </span>
      }
      @if (effectObject.type === 'checkbox') {
        <span class="checkbox-container">
          @for (
            checkboxEffect of effects;
            track (typeof checkboxEffect === 'object' ? checkboxEffect.type : checkboxEffect) + $index;
            let i = $index
          ) {
            <label [ngClass]="{ 'has-value': checkboxEffect }">
              <span
                class="checkbox"
                [ngClass]="{ checked: checks() > i, light: light() }"
                ghs-pointer-input
                (singleClick)="check(i)"
              ></span>
              @if (checkboxEffect) {
                <ghs-event-card-effect
                  [effect]="checkboxEffect"
                  [edition]="edition"
                  [eventType]="eventType"
                  [light]="light()"
                  [inline]="true"
                  [selected]="checks() > i"
                ></ghs-event-card-effect>
              }
            </label>
          }
        </span>
      }
      @if (!concatenated() && settingsManager.settings.eventsApply && applicable) {
        <span class="automation-icon" [ngClass]="{ light: light() }" [ghs-tooltip]="'game.events.effects.automation'">
          <img class="hint-trigger ghs-svg" src="./assets/images/automation.svg" />
        </span>
      }
    </span>
  }
</span>
